import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorklistComponent } from './components/worklist/worklist.component';
import { LayoutHelpersModule } from '@layouts/layout-helpers/layout-helpers.module';
import { TasksModule } from '@modules/tasks/tasks.module';
import { RcpCommonLibraryModule } from '@core/modules/rcp-common-library/rcp-common-library.module';
import { WorklistRoutingModule } from './worklist-routing.module';
import { RouterModule } from '@angular/router';
import { WorklistSummaryHomeComponent } from './components/worklist-summary-home/worklist-summary-home.component';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { UserNotificationsModule } from '@modules/user-notifications/user-notifications.module';
import { WorklistIssuesComponent } from '@modules/worklist/modules/worklist-issues/components/worklist-issues/worklist-issues.component';

@NgModule({
    declarations: [
        WorklistComponent,
        WorklistSummaryHomeComponent,
        WorklistIssuesComponent,
    ],
    imports: [
        CommonModule,
        LayoutHelpersModule,
        TasksModule,
        RcpCommonLibraryModule,
        RouterModule,
        WorklistRoutingModule,
        MatIconModule,
        MatListModule,
        UserNotificationsModule,
    ],
})
export class WorklistModule {}
